<template>
  <div style="position: relative">
    <bgLayout>
      <titleBar :titleName="pageName"></titleBar>
      <div class="X" v-if="openModal" @click="closeModal">X</div>
      <contentBlock style="z-index: 10;">
        <div v-if="!openModal" class="content">
          <div class="title">
            帳號密碼
          </div>
          <div class="form">
            <div class="input-block" style="margin-top: 20px">
              <div class="label">帳號</div>
              <input type="text" disabled :value="phoneText">
            </div>
            <div class="input-block">
              <div class="label">輸入密碼</div>
              <input type="password" v-model="password">
            </div>
            <p class="errorMsg" v-if="passwordError">限6-30字元，不能與手機號碼相同</p>
            <div class="input-block">
              <div class="label">確認密碼</div>
              <input type="password"  v-model="rePassword">
            </div>
            <p class="errorMsg"  v-if="rePasswordError">限6-30字元，不能與手機號碼相同</p>
            <p class="errorMsg"  v-if="sameError">確認密碼不同</p>
            <div class="input-block" v-if="showName">
              <div class="label">姓名</div>
              <input type="text" v-model="name">
            </div>
            <p class="errorMsg"  v-if="nameEmpty">請輸入姓名</p>
          </div>
          <div class="botton-block">
            <subButtonMin action-name="會員條款" @action="openMemberList"></subButtonMin>
            <subButtonMin action-name="隱私權政策" @action="openPrivacyPolicy"></subButtonMin>
          </div>
          <div class="check-box-block">
            <input type="checkbox" v-model="agree" id="agreeBox">
            <label for="agreeBox">我同意上述政策及其條款</label>
          </div>
          <p class="errorMsg" style="text-align: left" v-if="agreeEmpty">請同意條款</p>

          <mainButton style="margin: 30px 0px;" action-name="註冊" @action="formCheck"></mainButton>
        </div>
        <div class="textContent" v-if="openModal && pageName === '隱私權條款'">
          <p class="mt20 title">隱私權保護聲明</p>
          <p>1.『本公司』或『我們』即為中華汽車工業股份有限公司、華菱汽車股份有限公司以及綠捷股份有限公司。</p>
          <p>2.『IOV會員服務』即我們提供之功能和服務，包括透過（a）我們的網站mitsubishi-motors.com.tw 、china-motor.com.tw、5230.com.tw、emoving.com.tw、greentrans.com.tw、grandlancer.mitsubishi-motors.com.tw、outlander.com.tw、coltplus.com.tw、zinger.com.tw、等 （包括各產品網站、子網域、行動版本）；（b）其他現在或未來開發之軟體（如APP）、產品、媒體、服務或裝置。</p>
          <p>3.『會員』即您透過IOV會員服務，提供您之個人資料，向我們註冊成為IOV會員服務之使用者。</p>
          <p>4. 本公司非常感謝您對我們的優良產品有興趣，並且使用IOV會員服務！關於您個人的隱私權，本公司會絕對尊重並提供完整之保護，我們亦將依照現行法律規範致力於維護您的隱私權，請您安心的使用IOV會員服務。但請您注意，對於IOV會員服務所連結至其他網站並不在本隱私權聲明保障之範圍。</p>
          <p class="title">隱私權聲明之認同</p>
          <p>如您使用IOV會員服務，即表示您接受本隱私權聲明。如果您不接受本隱私權聲明時，請勿在IOV會員服務提供您的個人資料。請您瞭解，如果您選擇不在IOV會員服務上提供個人基本資料，您將無法使用部分內容，例如進入IOV會員服務特定頁面或區域、簡訊或推播、參加抽獎或比賽活動、索取型錄或樣品、或收到我們寄給您的電子郵件。</p>
          <p class="title">隱私權保護政策的適用範圍</p>
          <p>隱私權保護政策內容，包括如何處理在您使用IOV會員服務時收集到的個人識別資料。隱私權保護政策不適用於IOV會員以外的相關連結網站和APP，也不適用於非IOV會員所委託或參與管理的人員。</p>
          <p class="title">個人資料的蒐集、處理及利用方式</p>
          <p>當您使用IOV會員服務所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，IOV會員不會將個人資料用於其他用途。</p>
          <p>IOV會員服務在您使用各種相關服務、問卷調查等互動性功能時，會保留您所提供的個人資料，例如：姓名、地址、電話號碼、信用卡資料、暱稱、電子郵件地址及使用時間等。</p>
          <p>於瀏覽一般IOV會員服務時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進IOV會員服務的參考依據，此記錄為內部應用，決不對外公佈。</p>
          <p>為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</p>
          <p>基於IOV會員所提供之各項會員服務，您同意於註冊時提供正確詳實之個人資料，您所登錄之資料事後有變更時，應隨時於線上更新之，或回覆郵件（0800@china-motor.com），表明您有意修改或刪除個人資料的要求，我們即會按您的要求作出變更。</p>
          <p class="title">資料之保護</p>
          <p>IOV會員服務主機均設有防火牆、防毒系統等科技化和組織性防衛措施相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將承擔相關的法律責任。</p>
          <p>如因業務需要有必要委託其他單位提供服務時，我們亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</p>
          <p class="title">IOV會員服務對外的相關連結</p>
          <p>IOV會員服務提供其他網站的網路連結，您也可經由所提供的連結，點選進入其他網站或開啟其他軟體項目。但該連結網站不適用IOV會員服務的隱私權保護政策，您必須參考該連結中的隱私權保護政策。</p>
          <p class="title">與第三人共用個人資料之政策</p>
          <p>IOV會員服務絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合作廠商或個人合約義務者，不在此限。前項但書之情形包括不限於：‧經由您書面同意。‧法律明文規定。‧為免除您生命、身體、自由或財產上之危險。‧與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。‧當您在IOV會員服務的行為，違反服務條款或可能損害或妨礙網站或APP與其他使用者權益或導致任何人遭受損害時，經管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。‧有利於您的權益。  ‧IOV會員服務委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</p>
          <p class="title">Cookie之使用</p>
          <p>為了提供您最佳的服務，IOV會員服務會在您的電腦或穿戴手持裝置中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至IOV會員服務某些功能無法正常執行 。</p>
          <p class="title">隱私權保護政策之修正</p>
          <p class="mb20">本公司保留得逕自變更或撤銷本隱私權聲明之權利，並建議您經常瀏覽本隱私權聲明以掌握最新資訊。</p>
        </div>
        <div class="textContent" v-if="openModal && pageName === '會員使用條款'">
          <p class="mt20 title">遵守會員規範及法律規定</p>
          <p>遵守會員規範及法律規定 當您註冊成為會員後，可使用中華汽車IOV會員相關服務。會員使用中華汽車IOV會員服務時，視為會員同意接受本會員條款及同意書和所有注意事項之拘束，並同意遵守中華民國或您所在地之相關法規及一切國際網際網路規定與慣例。</p>
          <p>會員服務所提供之所有相關APP、網域名稱、網路位址、功能以及其他一切因會員身分得享有之權益，均仍屬本公司或其他合法權利人所有，會員除僅得於服務期間內依本使用條款之約定為使用外，均不得以任何方式將其轉讓、移轉、出租或出借予其他任何第三人。</p>
          <p>會員服務僅依當時所提供之功能及狀態提供服務；本公司並保留新增、修改或取消會員服務內相關系統或功能之全部或一部之權利。</p>
          <p class="title">服務簡介</p>
          <p>本公司網路及軟體服務係透過包括但不限於APP、e-mail、簡訊、網際網路等方式，提供會員各項網路資訊服務。會員必須自行配備上網所需之各項設備，以及負擔接上網際網路之相關費用。</p>
          <p>基於本公司所提供之各項服務，在使用會員服務以前，您必須經過完整的註冊手續並同意於註冊時提供完整詳實且符合真實之個人資料，您所登錄之資料事後有變更時，應隨時於線上更新之。</p>
          <p>您提供之個人資料若有填寫不實，或原登錄之資料已不符而未更新，或有任何誤導之嫌，本公司保留隨時終止您會員資格及使用各項服務資格之權利。如果您提供之個人資料違反或破壞本公司服務宗旨，本公司保留隨時終止您會員資格及使用各項服務資格之權利。若您使用虛偽或其他任何不正當之方式進行"儲值"或累積積分或積點，本公司也將保留隨時終止您的會員資格及使用各項服務之權利。</p>
          <p class="title">會員資料之修改與刪除</p>
          <p>基於本公司所提供之各項服務，您同意於註冊時提供正確詳實之個人資料，您所登錄之資料事後有變更時，應隨時於線上更新之，或回覆郵件(0800@china-motor.com)，表明您有意修改或刪除個人資料的要求，我們即會按您的要求作出變更。您提供之個人資料若有填寫不實，或原登錄之資料已不符而未更新，本公司保留隨時終止您的會員資格及使用各項服務資格之權利。如有任何虛假或冒用他人名義登錄，您應自負法律責任。如果您提供之個人資料違反或破壞本公司服務宗旨，本公司保留隨時終止您的會員資格及使用各項服務資格之權利。</p>
          <p class="title">隱私權保護</p>
          <p>為提供您更貼心更友善的本公司網路及軟體服務，我們將於您登入會員後記錄您瀏覽本公司網路及軟體服務的動線，以作為改善網站服務的參考依據。</p>
          <p>在未獲得會員書面（含電子郵件）同意以前，本公司將不對外揭露您於網路及軟體服務登錄或留存之個人資料，除下列情況外： 應司法機關或其他有權機關基於法定程序之提出要求；會員有任何違反本會員條款之情形，本公司合理懷疑有不法情事發生時，得主動將您的相關資料提供檢警調機關調查處理。</p>
          <p>對於您所登錄或留存之個人資料，您同意接受本公司之「隱私權保護」聲明 ( 請參閱「隱私權保護聲明」 )</p>
          <p class="title">會員條款之修改</p>
          <p>本公司保留隨時修改本會員條款之權利， 修正後之會員條款將於本公司網站相關網頁公告，並自公告之日起即時生效，不另作個別的通知。若您於網站公告修改或變更會員條款後繼續本公司網站以及各項APP服務所提供之服務，將視為您已閱讀同意接受該等修改或變更。如果您不同意本會員條款的內容，或者您所屬的國家或地域排除本同意書內容之全部或部份時，您應立即停止使用本公司之網路及軟體服務。</p>
          <p class="title">服務中止與修改</p>
          <p>本公司保留隨時中止或更改各項服務內容，或終止任一會員帳戶服務之權利。無論任何情形，就中止或更改服務或終止會員帳戶服務之決定，本公司對會員或第三人均不負任何賠償或補償責任。 您應瞭解並同意，本公司可能因公司、其他協力廠商或相關電信業者網路系統、軟硬體設備之故障或失靈或人為操作上之疏失而全部或部份中斷、暫時無法使用、遲延、或造成資料傳輸或儲存上之錯誤、或遭第三人侵入系統篡改或偽造變造資料等，本公司不負任何賠償責任。</p>
          <p>如發生下列情形時，本公司有權停止或中斷提供服務。對此產生困擾、不便或損害，本公司對任何會員或第三者均不負任何責任： 發生突發性之電子通信設備故障時；本公司所申請之電子通信服務遭中止，無法提供服務時；由於天災等不可抗力之因素致使無法提供服務時；在緊急情況下為維護其他會員或第三人之人身安全時。</p>
          <p>您瞭解本公司網站以及各項APP服務的服務與資訊供會員使用，但不對任何服務或資訊傳送的遲延、儲存的故障以及任何資訊的刪除負任何責任。</p>
          <p class="title">保管及通知義務</p>
          <p>您有義務妥善保管在本公司網路及軟體服務註冊之帳號與密碼，並於每次使用完本公司所提供之服務後確實登出，以防他人盜用。您應為以此組帳號與密碼登入本公司網路及軟體服務後所進行之一切行為負責。為維護您自身權益，請勿將帳號與密碼洩露或提供予第三人知悉，或出借或轉讓他人使用，若因您保管疏失，而導致帳號、密碼遭他人非法使用時，本公司將不負責賠償責任。若您發現帳號或密碼遭人非法使用或有任何異常破壞使用安全之情形時，應立即通知本公司， 若因未及時通知本公司以致無法有效防止或修護時，您應自負全責。</p>
          <p class="title">責任限制</p>
          <p>會員應瞭解並同意，本公司可能因公司、其他協力廠商或相關電信業者網路系統、軟硬體設備之故障或失靈或人為操作上之疏失而全部或部份中斷、暫時無法使用、遲延、或造成資料傳輸或儲存上之錯誤、或遭第三人侵入系統篡改或偽造變造資料等，會員不得因此而要求任何補償或賠償。</p>
          <p class="title">風險承擔</p>
          <p>您同意使用本公司網路及軟體服務係基於您的個人意願，並同意自負任何風險，包括因為自本公司下載資料或圖片，或自本公司服務中獲得之資料導致您的電腦或手持系統損壞，或是發生任何資料流失等結果。</p>
          <p class="title">特別同意事項</p>
          <p>會員同意絕不使用本公司各項服務來傷害、侵犯或攻擊本公司之雇主、員工、顧問、關係企業、廣告主以及相關合作廠商。</p>
          <p class="title">個人資料利用</p>
          <p>對於您所登錄或留存之個人資料，您同意本公司及其關係企業、本公司各經銷商或其合作簽約對象，得於加入中華汽車IOV會員、行銷、提供客戶服務、執行業務、研究分析、市場調查等目的內於台灣地區及本公司海外分支機構所在地蒐集、處理、保存、傳遞及使用該等資料，以提供使用者其他資訊或服務〈含定期以電子郵件提供電子報、簡訊、推播等方式〉、或作成會員統計資料、或進行關於網路行為之調查或研究或提供優惠訊息等行銷行為，或為任何之合法使用。截至您主動請求本公司刪除、停止處理或利用其個人資料為止，但依據法令需繼續保存您個人資料者，則不在此限。您得自由選擇是否提供個人資料，但您若不願提供個人資料，將無法加入中華汽車IOV會員。您有權向本公司查詢或閱覽並自行補正您的個人資料，亦得隨時洽本公司〈0800@china-motor.com〉表示拒絕本公司繼續蒐集、處理、利用或刪除您的個人資料。  您亦了解，同意上述事項為您接受本公司所提供或安排之各項服務之必要條件。會員得自由選擇是否要接受本公司所提供或安排之各項服務。基於法律之規定；受司法機關或其他有權機關基於法定程序之要求；為保障本公司之財產及權益；在緊急情況下為維護其他會員或第三人之人身安全；為維護會員服務系統的正常運作。本公司合理懷疑有不法情事發生時，本公司主動將相關資料提供檢警調機關調查處理。</p>
          <p class="title">擔保責任免除</p>
          <p>本公司就各項服務，不負任何明示或默示之擔保責任。本公司不保證各項服務之穩定、安全、無誤及不中斷。會員明示承擔使用本服務之所有風險及可能致生之任何損害。  對於透過本公司網路及軟體服務銷售之商品，本公司對其交易過程及商品本身，均不負任何擔保責任。會員了解您透過本公司網路及軟體服務所購得之商品或服務，完全由商品或服務提供人負全責，若有任何瑕疵或擔保責任，均與本公司無關。  為確保您的安全，在步行或開車期間請不要使用本公司網路及軟體服務，以免發生意外事故。所提供之相關行車便利資訊係連結外部資訊，包括:國道及快速道路即時路況和車流影像等、交通時刻、航班、行動繳費等其他網站外部連結，僅供您參考及運用，如資料有任何錯誤或與實際不符之處，本公司恕不負責。</p>
          <p class="title">賠償責任限制</p>
          <p>本公司對於會員使用各項服務、或無法使用各項服務所致生之任何直接、間接、衍生、或特別損害，不負任何賠償責任。若會員使用之服務係有相對現金價格者，本公司僅於會員所付之相對現金價格範圍內，負賠償責任，最高金額以5美金為上限。  上述賠償責任限制，若依法為不得限制者，則限制規定將不予適用。</p>
          <p class="title">智慧財產權</p>
          <p>本公司網路及軟體服務內之所有著作及資料，其著作權、專利權、商標、營業秘密、其他智慧財產權、所有權或其他權利，均為本公司或其權利人所有，除事先經本公司或其權利人之合法授權外，您不得擅自重製、散布、傳輸、改作、編輯、租用、出售或以其他任何形式、基於任何目的加以使用，否則應自負所有法律之責任。  本公司網路及軟體服務之內容及程式為本公司之智慧財產，未經本公司授權，不得擅自複製、進行還原工程〈reverse engineering〉、解編〈de-compile〉或反向組譯〈disassemble〉任何功能或程式。本公司只提供您以登入的方式使用需會員資格的服務，若以其他任何方式進入本公司網路及軟體服務系統，本公司將追究該人員相關之法律責任。</p>
          <p class="title">連結</p>
          <p>本公司網路及軟體服務或所有相關內容上所提供之所有連結，可能連結到其他個人、公司或組織之網站，提供該等連結之目的，僅係為便利您自行搜集或取得資訊，本公司對於被連結之該等個人、公司或組織之網站上所提供之產品、服務或資訊，既不擔保其真實性、完整性、即時性或可信度，該等個人、公司或組織亦不因此而當然與本公司有任何僱傭、委任、代理、合夥或其他類似之關係。如果您連結至第三方網站或廣告，所有因此而生的風險，應由您自行負責，本公司不會為您與任何廣告商或第三方網站經營者之間的任何交易承擔任何責任。</p>
          <p class="title">會員的義務與責任</p>
          <p>會員對會員本身於本公司或透過本公司相關網站傳輸的一切內容自負全責。會員承諾遵守中華民國相關法規及一切國際網際網路規定與慣例。若使用本公司台灣地區以外之網站，同意遵守各該網站當地之法令及網路慣例。 會員同意不會於本公司的相關網站上從事廣告或販賣商品行為。會員同意避免在公眾討論區討論私人事務，發表文章時，請尊重他人的權益及隱私權。會員同意必須充份尊重著作權，禁止發表侵害他人各項智慧財產權之文字、圖片或任何形式的檔案。  會員同意所有利用會員服務所提供之電子賀卡傳送之電子郵件，均僅代表您的個人立場，而與本公司無涉。會員同意並保證不未經同意收集他人電子郵件位址以及其他個人資料。會員同意並保證不公布或傳送任何毀謗、不實、威脅、不雅、猥褻、不法、攻擊性、毀謗性或侵害他人智慧財產權的文字，圖片或任何形式的檔案於本公司的相關網站上。  會員同意會員帳號內任何文字、圖檔、圖片或其他資料發生權利歸屬或其他合法性爭議，本公司有權隨時不經通知，直接停止提供、或直接刪除、或通知會員停止使用。  會員服務內之各類文字、圖檔、圖片及其他資料，其著作權或其他相關智慧財產權均仍屬於本公司所有，僅限於您個人使用，未經事前授權您不可以將這些文字、圖檔、圖片或其他著作或資料用於任何其他用途。  會員同意並保證不破壞或不干擾會員服務的系統運作或違反一般網路禮節之行為。  會員同意並保證不透過任何不正當管道竊取會員服務之會員帳號、密碼或存取權限之行為。會員同意並保證不未經授權下進入會員服務系統或是與系統有關之網路、或冒用他人帳號或偽造寄件人辨識資料傳送郵件，企圖誤導收件人之判斷。會員同意積點活動若經由不當方式累積，本公司將隨時終止積點累積或終止會員資格及服務；積點活動於兌換取得回饋項目前，不構成車主之資產，不得轉讓他人，亦不提供積點活動折現或其他非回饋項目之給付，在特定及具爭議情況下，本公司保留對會員兌換贈品審核通過與否之決定權利。會員帳戶中所累積之積點數以本公司系統資料庫中的紀錄為準。本公司保留變更、終止積點方案之權利，若有變更或終止之情形，將公告於網站上。 禁止從事違反法律規定之行為  本公司就會員的行為是否符合會員規範，有最終決定權。若本公司決定會員的行為違反本會員規範或任何法令，會員同意本公司得隨時停止帳號使用權或清除帳號，及停止使用本公司服務。會員在違反法律規定之情事，應自負法律責任。</p>
          <p class="title">損害賠償</p>
          <p>因會員違反相關法令或違背本同意書之任一會員條款，致本公司或其關係企業、受僱人、受託人、代理人及其他相關履行輔助人因此而受有損害或支出費用（包括且不限於因進行民事、刑事及行政程序所支出之律師費用）時，會員應負擔損害賠償責任或補償其費用。</p>
          <p class="title">廣告信息或促銷計劃</p>
          <p>會員了解本公司上刊登有商業廣告及各種商品之促銷資訊。該等內容均係由廣告商或商品服務提供人所為，本公司僅係提供刊登內容之媒介。會員透過本公司上所提供之商品、服務資訊，所購買之任何商品或服務，其間交易關係均存在於會員與商品或服務提供人間，與本公司無關。</p>
          <p class="title">個別條款之效力</p>
          <p class="mb20">本條款及同意書之全部或部分無效時，不影響其他條款之效力。</p>
        </div>

      </contentBlock>
    </bgLayout>
    <loading :isLoading="isLoading"></loading>
  </div>
</template>

<script>
import titleBar from "../../components/titleBar";
import bgLayout from "../../components/bgLayout";
import contentBlock from '../../components/contentBlock'
import mainButton from "../../components/mainButton";
import subButtonMin from "../../components/subButtonMin";
import loading from "../../components/loading";
import liff from "@line/liff";

export default {
  components:{
    titleBar,
    bgLayout,
    contentBlock,
    mainButton,
    subButtonMin,
    loading
  },
  data(){
    return{
      agree: false,
      pageName: '註冊會員',
      openModal :false,
      phone: '',
      phoneText: '',
      password: '',
      passwordError: false,
      rePassword: '',
      rePasswordError: false,
      name:'',
      nameEmpty: false,
      sameError: false,
      isLoading: false,
      agreeEmpty: false,
      showName: true,
    }
  },
  mounted() {
    if(this.$route.query.hasData === 'true'){
      this.showName = false
    }
    let phone = window.localStorage.getItem('phone')
    this.phone = phone
    let phoneArray = phone.split('')
    this.phoneText = phoneArray[0] + phoneArray[1]+ phoneArray[2]+ phoneArray[3]+ '-' +phoneArray[4]+ phoneArray[5]+ phoneArray[6] + '-'+ phoneArray[7]+ phoneArray[8]+ phoneArray[9]

  },
  methods:{
    async  fetchUserData(){
      let url = process.env.VUE_APP_APIUrl + 'getMember'
      this.axios.post(url, {}, {
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then( res =>{
        console.log(res.data.data)
        if(res.data.msg=== 'success'){
          this.$router.push({ path : '/member/memberData'})
        }
      })
      .catch(e =>{
        console.log(e)
      })
    },
    formCheck(){
      this.nameCheck()
      this.passwordCheck()
      this.rePasswordCheck()
      this.agreeCheck()
      if(
          this.passwordError === false &&
          this.rePasswordError === false &&
          this.nameEmpty === false &&
          this.sameError === false &&
          this.agree === true
      ){
        if(this.showName === true){
          this.register()
        }else if(this.showName === false){
          this.updatePassword()
        }
      }

    },
    nameCheck(){
      if(this.showName === true){
        if( this.name === ''){
          this.nameEmpty = true
        }else{
          this.nameEmpty = false
        }
      }
    },
    passwordCheck(){
      if( this.password === ''){
        this.passwordError = true
      }else{
        this.passwordError = false
      }
    },
    rePasswordCheck(){
      if( this.rePassword === ''){
        this.rePasswordError = true
      }else{
        this.rePasswordError = false
      }
    },
    agreeCheck(){
      if(!this.agree){
        this.agreeEmpty = true
      }else{
        this.agreeEmpty = false
      }
    },
    updatePassword(){
      this.isLoading = true
      let url = process.env.VUE_APP_APIUrl + 'resetPassword'
      let data = {
        "mobile": this.phone,
        "newPassword": this.password,
        "authCode": this.$route.query.t
      }
      this.axios.post(url, data, {
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then( res =>{
        this.$swal({
          text: res.data.data,
        })
        this.isLoading = false
        this.$router.push({path: '/member/memberData'})
      })
      .catch(e =>{
        console.log(e)
        // alert('系統錯誤 請洽客服')
        this.$swal({
          text: '系統錯誤 請洽客服',
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "確定"
        }).then((result) => {
          console.log(result)
          this.isLoading = false
          liff.closeWindow()
        })
      })
    },
    register(){
      this.isLoading = true
      let url = process.env.VUE_APP_APIUrl + 'register'
      let data = {
        "mobile": this.phone,
        "password": this.password,
        "name": this.name
      }
      console.log(url)
      console.log(data)
      this.axios.post(url, data, {
        headers:{
          Authorization: 'Bearer ' + window.localStorage.getItem('AccessToken')
        }
      }).then( res =>{
        console.log(res)
        this.isLoading = false
        if(res.data.msg === 'success'){
          // alert('新增會員成功，且Line OA綁定成功!')
          this.$swal({
            text: '新增會員成功，下一步前往綁定車籍',
            confirmButtonText: '前往綁定車籍'
          }).then(() => {
            this.$router.push({ path: '/member/carData' })
          })
          // this.$router.push({ path : '/member/memberData'})
        }
      })
      .catch(e =>{
        console.log(e)
        this.isLoading = false
        // alert('發生錯誤或已加入好友 請洽客服')
        this.$swal({
          text: '發生錯誤或已加入好友 請洽客服',
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "確定"
        }).then((result) => {
          console.log(result)
          liff.closeWindow()
        })
      })
    },
    openMemberList(){
      this.openModal= true
      this.pageName = '會員使用條款'
    },
    openPrivacyPolicy(){
      this.openModal= true
      this.pageName = '隱私權條款'
    },
    closeModal(){
      this.openModal= false
      this.pageName = '註冊會員'
    }
  },
  watch:{
    name:{
      handler: function(newValue){
        if( newValue == ''){
          this.nameEmpty = true
        }else{
          this.nameEmpty = false
        }
      },
    },
    password:{
      handler: function(newValue){
        if( newValue == ''){
          this.passwordError = true
        }else{
          let arr = newValue.split('')
          if(arr.length < 6){
            this.passwordError = true
          }else if(arr.length > 30){
            this.passwordError = true
          }else {
            if(newValue === this.phone){
              this.passwordError = true
            }else{
              this.passwordError = false
            }
          }
        }
      },
    },
    rePassword:{
      handler: function(newValue){
        if( newValue == ''){
          this.rePasswordError = true
        }else{
          let arr = newValue.split('')
          if(arr.length < 6){
            this.rePasswordError = true
          }else if(arr.length > 30){
            this.rePasswordError = true
          }else {
            if(newValue === this.phone){
              this.rePasswordError = true
            }else{
              this.rePasswordError = false
            }
          }

          if(newValue !== this.password){
            this.sameError = true
          }else {
            this.sameError = false
          }
        }
      },
    },
  }
}
</script>

<style lang="scss" scoped>
.X{
  position: absolute;
  top: 6px;
  left: 22px;
  font-size: 32px;
  color: white;
  z-index: 10;
}

.textContent{
  z-index: 10;

  p{
    width: 90%;
    margin: 0 auto;
    font-size: 14px;
  }

  .mt20{
    margin-top: 20px;
  }

  .mb20{
    margin-bottom: 20px;
  }

  .title{
    font-weight: bold;
    margin-top: 8px;
    font-size: 16px !important;
  }
}
.content{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .title{
    margin-top: 20px;
    width: 90%;
    display: flex;
    align-items: center;
    font-weight: bold;
  }

  .hints{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c1c1c1;
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
  }

  .form{
    width: 90%;

    .input-block{
      width: 100%;
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 10px 0px;
      .label{
        width: 30%;
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        align-items: center;
        font-size: 16px;
      }
      input{
        width: 70%;
        border: 1px solid #c1c1c1;
        height: 40px;
        border-radius: 8px;
        z-index: 10;
        text-align: right;
        padding-right: 8px;
      }
    }
  }



  input:focus{
    outline: none;
  }

  input::placeholder {
    color: #c1c1c1;
    font-weight: bold;
  }

  p{
    font-size: 8px;
    margin-top: 8px;
  }

  .botton-block{
    width: 90%;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
  }

  .check-box-block{
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    width: 90%;
    margin-top: 12px;
    z-index: 10;
    input{
      width: 18px;
      height: 18px;
    }
    label{
      margin-left: 2px;
      font-weight: bold;
    }
  }
}

.errorMsg{
  color: red;
  width: 90%;
  text-align: right;
  margin: 0 auto;
  font-size: 16px;
}
</style>
